'use client';

import { createReverseProposalService } from '@musinsa/services-curator';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useCreateReverseProposal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createReverseProposalService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: curatorQueries.campaigns.reverseProposals._def,
      });
    },
  });
};
